import { queryKeys } from '@sshop/api-client';
import type { ProductListQuery } from '@sshop/domain';

import { api } from '@/shared/lib/apiClient';
import { defineQuery } from '@/shared/lib/queryFactory';
import { routeLocale } from '@/shared/lib/routeLocale';

export const productListQuery = (filters: ProductListQuery) => {
  return defineQuery({
    queryKey: queryKeys.product.list({ ...filters, locale: routeLocale() }),
    queryFn: ({ signal }) => api.products.list(filters, signal),
    staleTime: 60_000,
  });
};
